<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-left">
        <div
          v-show="stateArrow"
          id="leftBox"
          class="leftBox"
          style="width: 206px"
        >
          <vue-draggable-resizable
            :min-width="160"
            @resizing="onResize"
            :max-width="400"
            :draggable="false"
            :handles="['mr']"
            :w="206"
            :parent="false"
          >
            <el-scrollbar>
              <tree
                :isSearch="isSearch"
                @initFun="initQuery"
                @nodeClick="nodeClick"
              ></tree>
            </el-scrollbar>
          </vue-draggable-resizable>
        </div>
        <div class="leftCaret" @click="changeArrow">
          <i
            :class="stateArrow ? 'el-icon-caret-left' : 'el-icon-caret-right'"
          ></i>
        </div>
      </div>
      <div class="tableStyle-right">
        <div class="carStateTable">
          <el-scrollbar>
            <div class="rightAll">
              <div class="rightAll-form">
                <el-form
                  :inline="true"
                  :model="formInline"
                  class="demo-form-inline"
                >
                  <el-form-item :label="$t('common.carId')">
                    <el-input
                      size="mini"
                      v-model="formInline.carId"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="input-with-select"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('common.terminalId')">
                    <el-input
                      size="mini"
                      v-model="formInline.terminalId"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="input-with-select"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('SafeManagement.terminalType')">
                    <el-select
                      @change="indexSelect('query')"
                      v-model="formInline.terminalType"
                      :placeholder="$t('OTAManagement.typeIdStr')"
                      filterable
                      size="mini"
                      style="width: 120px"
                    >
                      <el-option
                        v-for="item in terminalList"
                        :key="item.id"
                        :label="item.terminalType"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                    <el-select
                      v-model="formInline.aliKey"
                      :placeholder="$t('SafeManagement.aliKey')"
                      filterable
                      size="mini"
                      style="width: 120px; margin-left: 5px"
                    >
                      <el-option
                        v-for="item in aliKeyList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('common.createTime')">
                    <el-date-picker
                      v-model="formInline.OperatingTime"
                      type="daterange"
                      style="width: 220px"
                      size="mini"
                      value-format="yyyy-MM-dd"
                      range-separator
                      :start-placeholder="$t('common.btn.choseDate')"
                      end-placeholder
                    ></el-date-picker>
                  </el-form-item>
                  <el-form-item>
                    <el-button
                      size="mini"
                      type="primary"
                      @click="onSearch"
                      class="btn-chaxun"
                      >{{ $t("common.btn.search") }}</el-button
                    >
                    <el-button size="mini" @click="onClear" class="btn-del">{{
                      $t("common.btn.cancel")
                    }}</el-button>
                  </el-form-item>
                </el-form>
              </div>
              <div class="rightAll-btn">
                <el-button
                  v-if="isPrimaryKey('EQUIPMENTCONTROL_RETRY')"
                  type="text"
                  :disabled="selected.length == 0"
                  @click="retry"
                  >{{ $t("SafeManagement.retry") }}</el-button
                >
                <el-button
                  v-if="isPrimaryKey('EQUIPMENTCONTROL_CANCEL')"
                  type="text"
                  :disabled="delDisabled"
                  @click="CancelSend"
                  >{{ $t("common.btn.cancel") }}</el-button
                >
                <el-button
                  v-if="isPrimaryKey('EQUIPMENTCONTROL_NEWSIMPLECONFIGURATION')"
                  type="text"
                  @click="addSimple"
                  >{{ $t("SafeManagement.btn.addSimpleSet") }}</el-button
                >
                <!-- <el-button
                  v-if="isPrimaryKey('EQUIPMENTCONTROL_NEWCOMPLEXCONFIGURATION')"
                  type="text"
                  @click="addComplex"
                  >{{ $t("SafeManagement.btn.addComPlexSet") }}</el-button
                > -->
                <el-button
                  v-if="isPrimaryKey('EQUIPMENTCONTROL_DOWNTEMPLATE')"
                  type="text"
                  @click="BulkImport()"
                  >{{ $t("SafeManagement.btn.downloadModle") }}</el-button
                >
                <el-button
                  v-if="isPrimaryKey('EQUIPMENTCONTROL_DOWN')"
                  type="text"
                  @click="downCar"
                  >{{ $t("common.btn.download") }}</el-button
                >
              </div>
              <i-table
                :list="list"
                :height="height"
                ref="carTable"
                @handleSelectionChange="handleSelectionChange"
                :options="option"
                :columns="columns"
                :operates="operates"
              ></i-table>
              <IPagination ref="page" @PageFun="changeSize"></IPagination>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <el-dialog
        width="620px"
        :before-close="closeDia"
        class="addDialong"
        :title="$t('SafeManagement.btn.addSimpleSet')"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
      >
        <el-form :rules="rules" ref="form" :model="form">
          <el-form-item
            prop="terminalType"
            :label="$t('OTAManagement.typeIdStr') + ':'"
            :label-width="formLabelWidth"
          >
            <el-select
              @change="indexSelect('add')"
              v-model="form.terminalType"
              :placeholder="$t('OTAManagement.typeIdStr')"
              filterable
            >
              <el-option
                v-for="item in terminalList"
                :key="item.id"
                :label="item.terminalType"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('OTAManagement.groupId') + ':'"
            :label-width="formLabelWidth"
            prop="groupId"
          >
            <el-select
              @change="changeStatus"
              v-model="form.groupId"
              :placeholder="$t('SafeManagement.form.uploadTerminalType')"
            >
              <el-option
                :label="$t('SafeManagement.form.selectTerminal')"
                value="0"
              ></el-option>
              <el-option
                :label="$t('OTAManagement.form.uploadTerminal')"
                value="1"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('SafeManagement.form.selectTerminal') + ':'"
            :label-width="formLabelWidth"
            v-if="groupStatus"
            prop="terminalId"
          >
            <el-input
              disabled
              class="fuInput"
              v-model="form.terminalId"
              placeholder=""
            ></el-input>
            <el-button
              class="fuButton"
              size="small"
              icon="el-icon-plus"
              @click="getNewCarInfo"
              >{{ $t("SafeManagement.form.selectTerminal") }}</el-button
            >
          </el-form-item>
          <el-form-item
            :label="$t('OTAManagement.uploadFile') + ':'"
            :label-width="formLabelWidth"
            v-else
          >
            <el-upload
              class="upload-demo"
              :action="processFile"
              :on-success="handleSuccess"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              multiple
              :file-list="FileList"
            >
              <el-button size="small" type="primary">{{
                $t("common.btn.clickUpload")
              }}</el-button>
              <div
                slot="tip"
                class="el-upload__tip"
                style="width: 200px; display: inline-block; margin-left: 10px"
              >
                {{ $t("common.btn.onlyUploadxlsOrxlsx") }}
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item
            prop="keyId"
            :label="$t('SafeManagement.keyName') + ':'"
            :label-width="formLabelWidth"
          >
            <el-select
              @change="getTypeKey"
              v-model="form.keyId"
              :placeholder="$t('common.form.keyId')"
              filterable
            >
              <el-option
                v-for="item in aliKeyList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            prop="sendContent"
            :label="$t('TerminalCommand.name') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.sendContent"
              autocomplete="off"
              :placeholder="placeholder"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancle('form')">{{
            $t("common.btn.cancel")
          }}</el-button>
          <el-button size="small" type="primary" @click="submitForm('form')">{{
            $t("common.btn.confirm")
          }}</el-button>
        </div>
      </el-dialog>
      <el-dialog
        width="620px"
        :before-close="closeServiceDia"
        class="addDialong"
        :title="$t('SafeManagement.btn.addComPlexSet')"
        :visible.sync="dialogServiceFormVisible"
        :close-on-click-modal="false"
      >
        <el-form :rules="serviceRules" ref="serviceForm" :model="serviceForm">
          <el-form-item
            prop="terminalType"
            :label="$t('OTAManagement.typeIdStr') + ':'"
            :label-width="formLabelWidth"
          >
            <el-select
              @change="indexService()"
              v-model="serviceForm.terminalType"
              :placeholder="$t('OTAManagement.typeIdStr')"
              filterable
            >
              <el-option
                v-for="item in terminalList"
                :key="item.id"
                :label="item.terminalType"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('OTAManagement.groupId') + ':'"
            :label-width="formLabelWidth"
            prop="groupId"
          >
            <el-select
              @change="changeStatus"
              v-model="serviceForm.groupId"
              :placeholder="$t('SafeManagement.form.uploadTerminalType')"
            >
              <el-option
                :label="$t('SafeManagement.form.selectTerminal')"
                value="0"
              ></el-option>
              <el-option
                :label="$t('OTAManagement.form.uploadTerminal')"
                value="1"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('SafeManagement.form.selectTerminal') + ':'"
            :label-width="formLabelWidth"
            v-if="groupStatus"
            prop="changeTerminalId"
          >
            <el-input
              disabled
              class="fuInput"
              v-model="serviceForm.terminalId"
              placeholder=""
            ></el-input>
            <el-button
              class="fuButton"
              size="small"
              icon="el-icon-plus"
              @click="getCarInfo"
              >{{ $t("SafeManagement.form.selectTerminal") }}</el-button
            >
          </el-form-item>
          <el-form-item
            :label="$t('OTAManagement.uploadFile') + ':'"
            :label-width="formLabelWidth"
            v-else
          >
            <el-upload
              class="upload-demo"
              :action="processFile"
              :on-success="handleServiceSuccess"
              :on-preview="handleServicePreview"
              :on-remove="handleServiceRemove"
              multiple
              :file-list="FileLists"
            >
              <el-button size="small" type="primary">{{
                $t("common.btn.clickUpload")
              }}</el-button>
              <div
                slot="tip"
                class="el-upload__tip"
                style="width: 200px; display: inline-block; margin-left: 10px"
              >
                {{ $t("common.btn.onlyUploadxlsOrxlsx") }}
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item
            prop="keyId"
            :label="$t('TerminalCommand.servSetting') + ':'"
            :label-width="formLabelWidth"
          >
            <el-select
              @change="getService"
              v-model="serviceForm.keyId"
              :placeholder="$t('SafeManagement.form.chooseServer')"
            >
              <el-option
                v-for="item in serviceList"
                :key="item.aliKey"
                :label="item.name"
                :value="item.aliKey"
              ></el-option>
            </el-select>
          </el-form-item>
          <div v-if="voiceStatus">
            <el-form-item
              prop="TTS_STRING"
              :label="$t('SafeManagement.voiceSet') + ':'"
              :label-width="formLabelWidth"
            >
              <el-input
                type="textarea"
                :rows="3"
                size="small"
                v-model="serviceForm.sendContent.TTS_STRING"
                autocomplete="off"
                :placeholder="$t('SafeManagement.form.importVoiceSet')"
              ></el-input>
            </el-form-item>
            <el-form-item
              prop="TTS_CNT"
              :label="$t('SafeManagement.setNum') + ':'"
              :label-width="formLabelWidth"
            >
              <el-input
                size="small"
                v-model="serviceForm.sendContent.TTS_CNT"
                autocomplete="off"
                :placeholder="$t('SafeManagement.form.importSetNum')"
              ></el-input>
            </el-form-item>
          </div>
          <div v-if="WIFIStatus">
            <el-form-item
              prop="SSID"
              :label="$t('SafeManagement.wifiName') + ':'"
              :label-width="formLabelWidth"
            >
              <el-input
                size="small"
                v-model="serviceForm.sendContent.SSID"
                autocomplete="off"
                :placeholder="$t('SafeManagement.form.importWifiName')"
              ></el-input>
            </el-form-item>
            <el-form-item
              prop="PWD"
              :label="$t('SafeManagement.wifiPassWord') + ':'"
              :label-width="formLabelWidth"
            >
              <el-input
                size="small"
                v-model="serviceForm.sendContent.PWD"
                autocomplete="off"
                :placeholder="$t('SafeManagement.form.importWifiPassWord')"
              ></el-input>
            </el-form-item>
          </div>
          <div v-if="initialStatus">
            <el-form-item
              :label="$t('SafeManagement.initializePassWord')"
              :label-width="formLabelWidth"
              prop="PASSWORD"
            >
              <el-input
                size="small"
                v-model="serviceForm.sendContent.PASSWORD"
                autocomplete="off"
                :placeholder="
                  $t('SafeManagement.form.importInitializePassWord')
                "
              ></el-input>
            </el-form-item>
          </div>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancleService('serviceForm')">{{
            $t("common.btn.cancel")
          }}</el-button>
          <el-button
            size="small"
            type="primary"
            @click="submitServiceForm('serviceForm')"
            >{{ $t("common.btn.confirm") }}</el-button
          >
        </div>
      </el-dialog>
      <el-dialog
        :title="$t('OTAManagement.addTermianlSetting')"
        :visible.sync="dialogVisibleTransfer"
        width="1200px"
        :before-close="handleClose"
        class="addDialong"
        v-if="isShowDialong"
        :close-on-click-modal="false"
      >
        <span
          ><i-Terminal
            v-if="delTransfer"
            ref="transfer"
            @postParam="postParam"
            :paramsData="paramsData"
            :id="id"
          ></i-Terminal
        ></span>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogVisibleTransfer = false">{{
            $t("common.btn.cancel")
          }}</el-button>
          <el-button size="small" type="primary" @click="assignment">{{
            $t("common.btn.confirm")
          }}</el-button>
        </span>
      </el-dialog>
      <el-dialog
        width="620px"
        :before-close="closeRetryDia"
        class="addDialong"
        :title="$t('SafeManagement.btn.retrySetOrder')"
        :visible.sync="dialogRetryFormVisible"
        :close-on-click-modal="false"
      >
        <el-form :rules="retryRules" ref="retryForm" :model="retryForm">
          <el-form-item
            :label="$t('SafeManagement.idNum')"
            :label-width="formRetryLabelWidth"
            prop="id"
          >
            <el-input
              disabled
              type="textarea"
              rows="5"
              v-model="retryForm.serialNumber"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancleRetry('retryForm')">{{
            $t("common.btn.cancel")
          }}</el-button>
          <el-button
            size="small"
            type="primary"
            @click="submitRetryForm('retryForm')"
            >{{ $t("common.btn.confirm") }}</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import EquipmentControl from "./EquipmentControl.js";
export default EquipmentControl;
</script>

<style lang="less" scoped>
@import "../../../assets/styles/Style.less";
</style>
